import React from "react";

import Toolsimg from '../../assets/services/Construction-Tools.png'
import ServiceForm from "../../components/Forms/ServiceForm";
import HeroBanner from "../../components/HeroBanner/HeroBanner";

const Services = () => {
  const title = "Services";
  const description =
    " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi,accusamus? Nisi, pariatur.";

  return (
    <div>
      <HeroBanner title={title} subtitle={description} />
      {/* cards  */}
      <div className="p-20 gap-5 lg:gap-16 flex flex-wrap items-center justify-center">
        {/* one  */}
        <div className="w-64 h-80 p-4 border-green-400 border rounded">
          <div>
            <img src={Toolsimg} alt="" className="w-full object-cover" />
          </div>
          <div className="py-2" >
            <h2 className="font-bold text-xl my-2">Construction</h2>
            <p className="text-xs font-semibold">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio
              beatae explicabo quo debitis officia esse distinctio similique
              vero minus id, error suscipit itaque neque!
            </p>
          </div>
        </div>
        {/* two  */}
        <div className="w-64 h-80 p-4 border-green-400 border rounded">
          <div>
            <img src={Toolsimg} alt="" className="w-full object-cover" />
          </div>
          <div className="py-2" >
            <h2 className="font-bold text-xl my-2">Construction</h2>
            <p className="text-xs font-semibold">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio
              beatae explicabo quo debitis officia esse distinctio similique
              vero minus id, error suscipit itaque neque!
            </p>
          </div>
        </div>
        {/* three  */}
        <div className="w-64 h-80 p-4 border-green-400 border rounded">
          <div>
            <img src={Toolsimg} alt="" className="w-full object-cover" />
          </div>
          <div className="py-2" >
            <h2 className="font-bold text-xl my-2">Construction</h2>
            <p className="text-xs font-semibold">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio
              beatae explicabo quo debitis officia esse distinctio similique
              vero minus id, error suscipit itaque neque!
            </p>
          </div>
        </div>
      </div>
      {/* form  */}
      <div className="p-2 md:p-20">
        <ServiceForm/>
      </div>
    </div>
  );
};

export default Services;
